
























































































































































import Vue from 'vue';
import ApiConfiguration from '@/classes/ApiConfiguration';
import { SingleSignOnConfigurationModel, AuthClientConfigurationModel } from '@/services/GeneratedApi';
import { FormFieldValidation } from '@/mixins';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { ValidationModel } from '@/types/models/validation';
import { ValueType, MStoreInputType, StoreConstants } from '@/types';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'SingleSignOnConfiguration',
  mixins: [FormFieldValidation],
  data() {
    return {
      isLoading: true,
      isSubmitting: false,
      isSubmittingEnabled: false,
      configuration: {} as SingleSignOnConfigurationModel,
      authClientIdToUpdate: null,
      authClientToUpdate: {} as AuthClientConfigurationModel,
      updateSecretSelected: false,
      showSecret: false,
      isSingleSignOnEnabledSubmitting: false
    };
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirtyOnModal']),
    async getConfiguration(this: any) {
      this.isLoading = true;
      try {
        this.configuration = await ApiConfiguration.api().singleSignOnConfiguration.singleSignOnConfigurationList();
      } catch (error) {
        this.$log('Failed to get single sign on configuration: ', error);
      } finally {
        this.isLoading = false;
      }
    },
    async onSubmit(this: any) {
      this.isSubmitting = true;
      try {
        await ApiConfiguration.api().singleSignOnConfiguration.singleSignOnConfigurationUpdate(this.authClientSubmit);
        await this.getConfiguration();
        this.setAuthClientToUpdate();
        SnotifyConfiguration.showSuccess(`${this.authClientToUpdate.provider} updated successfully.`);
      } catch (error) {
        this.$log('Failed to update single sign on configuration: ', error);
      } finally {
        this.isSubmitting = false;
      }
    },
    async onUpdateEnabled(this: any, reset: () => void) {
      this.isSubmittingEnabled = true;
      this.authClientToUpdate.isEnabled = !this.authClientToUpdate.isEnabled;

      try {
        await ApiConfiguration.api().singleSignOnConfiguration.singleSignOnConfigurationEnabledUpdate(this.authClientToUpdate);
        await this.getConfiguration();
        this.setAuthClientToUpdate();
        reset();
        if (!this.authClientToUpdate.isEnabled) {
          this.updateSecretSelected = false;
        }
        SnotifyConfiguration.showSuccess(`${this.authClientToUpdate.provider} ${this.authClientToUpdate.isEnabled ? 'enabled' : 'disabled'} successfully.`);
      } catch (error) {
        this.$log('Failed to update single sign on configuration: ', error);
      } finally {
        this.isSubmittingEnabled = false;
      }
    },
    async onCancel(this: any, reset: () => void) {
      await this.getConfiguration();
      this.setAuthClientToUpdate();
      reset();
    },
    setAuthClientToUpdate(this: any) {
      const authClient = this.configuration.authClients.find((item: any) => item.id === this.authClientIdToUpdate);
      if (!authClient) {
        this.authClientToUpdate = {} as AuthClientConfigurationModel;
      }
      this.authClientToUpdate = { ...authClient };
    },
    async onUpdateSingleSignOnEnabled(this: any) {
      this.isSingleSignOnEnabledSubmitting = true;
      const singleSignOnEnabled = !this.configuration.isSingleSignOnEnabled;

      try {
        await ApiConfiguration.api().singleSignOnConfiguration.singleSignOnConfigurationSinglesignonenabledUpdate({ enabled: singleSignOnEnabled });
        await this.getConfiguration();
      } catch (error) {
        this.$log(`Failed to ${singleSignOnEnabled ? 'enable' : 'disable'} single sign-on`, error);
      } finally {
        this.isSingleSignOnEnabledSubmitting = false;
      }
    }
  },
  computed: {
    ...mapGetters(StoreConstants.ApplicationDirty.ModuleName, [StoreConstants.ApplicationDirty.Getters.IsApplicationDirty]),
    enabledButtonLabel(this: any) {
      return this.authClientToUpdate.isEnabled ? 'Disable' : 'Enable';
    },
    clientSecretValidation(this: any) {
      return { ...this.defaultclientSecretValidation, required: this.updatingClientSecret };
    },
    clientSecretInputType(this: any) {
      return this.showSecret ? MStoreInputType.Text : MStoreInputType.Password;
    },
    haveAuthClients(this: any): boolean {
      return this.configuration.authClients.length > 0;
    },
    updatingClientSecret(this: any): boolean {
      return !this.authClientToUpdate.hasClientSecret || this.updateSecretSelected;
    },
    authClientSubmit(this: any): AuthClientConfigurationModel {
      return { ...this.authClientToUpdate, clientSecret: this.updatingClientSecret ? this.authClientToUpdate.clientSecret : '' };
    },
    selectedAuthClientId: {
      set(this: any, value: number) {
        this.authClientIdToUpdate = value;
        this.setAuthClientToUpdate();
      },
      get(this: any) {
        return this.authClientIdToUpdate;
      }
    },
    enabledSingleSignOnButtonLabel(this: any) {
      return this.configuration.isSingleSignOnEnabled ? 'Disable Single Sign-on' : 'Enable Single Sign-on';
    },
    isEnableSingleSignOnBuittonEnabled(this: any) {
      return this.isLoading || this.isSubmittingEnabled || this.isApplicationDirty;
    }
  },

  async mounted(this: any) {
    await this.getConfiguration();
  },
  created(this: any) {
    this.redirectUriValidation = {
      required: true,
      valueType: ValueType.Url,
      maxLength: 250
    } as ValidationModel;
    this.defaultclientSecretValidation = {
      required: true,
      valueType: ValueType.Any,
      maxLength: 250
    } as ValidationModel;
    this.clientIdValidation = {
      required: true,
      valueType: ValueType.Any,
      maxLength: 250
    } as ValidationModel;
  },
  components: {
    MStoreFormSelect: () => import('@/components/shared/MStoreFormSelect.vue'),
    LoadingSpinner: () => import('@/components/shared/LoadingSpinner.vue'),
    MStoreSpinnerButton: () => import('@/components/shared/MStoreSpinnerButton.vue'),
    MStoreFormCheckbox: () => import('@/components/shared/MStoreFormCheckbox.vue')
  }
});
